<template>
  <div class="projectsContainer">
    <div class="backimg">
      <img
        src="../../assets/img/product/DCI.png"
        alt=""
        style="width:100%;height: 100%;vertical-align:middle;"
      />
      <div class="betweencenter">
        <div class="real">
          <div class="tis bigcolor">{{$t('projectdci.title')}}</div>
          <div class="tixt middlecolorc">
            {{$t('projectdci.text')}}
          </div>
        </div>
      </div>
      <!-- 标题 -->
      <div class="contents">
        <div class="navs">
          <div
            v-for="(item, it) in $t('projectdci.textlist')"
            :key="it"
            class="list"
            :class="selected == it ? 'listback' : ''"
            @mouseover="mouseOver(it)"
          >
            <div class="jiesh">
              <div style="height:100px;">
                <img
                  :src="item.img"
                  alt=""
                />
              </div>
              <p class="middlecolor tixt fontw">
                {{ item.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div><p class="heif smallcolor" :title="about">{{ about | ellipsis }}</p>

    <div class="projectContent">
      <div class="headers">
        <img
          src="../../assets/img/product/title.png"
          alt=""
          class="conimg"
        />
        <span class="hfont fontw">{{ $t('projectdci.header') }}</span>
        <div class="matter colors">
          {{ $t('projectdci.matter') }}
        </div>
      </div>
    </div>
    <!-- 产品特色 -->
    <div class="specil">
      <h1>{{$t('projectdci.feature')}}</h1>
      <div class="botcolor">Product Presentation</div>
      <div class="navs">
        <div
          v-for="(item, index) in $t('projectdci.spelist')"
          :key="index"
          class="list"
          @mouseover="mouseOvers(index)"
        >
          <div class="jiesh">
            <div style="height:165px;">
              <img
                :src="item.img"
                alt=""
              />
            </div>

            <p
              class="tixt fontw"
              :class="selecteds == index ? 'green' : ''"
            >
              {{ item.name |ellipsisports}}
            </p>
            <p
              class="colors"
              :title="item.title"
            >{{ item.title | ellipsisprot }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="scene">
      <h1>{{$t('projectdci.scene')}}</h1>
        <div class="botcolor">Application scenario</div>
      <div class="menus">
        <div class="classl"><img
            :src="menuimg"
            alt=""
          /></div>
        <div class="classr">
          <div class="classt">
            <p class="font middlecolors fontw">{{ $t('projectdci.menustitle') }}</p>
            <ul>
              <li
                class="colors"
                style="line-height:30px;"
                v-for="(item, i) in $t('projectdci.text2')"
                :key="i"
              >
                • {{ item.title }}
              </li>
            </ul>
          </div>
          <div class="classb">
            <p class="font middlecolors fontw">{{ $t('projectdci.menustitles') }}</p>
            <ul>
              <li
                class="colors"
                style="line-height:30px;"
                v-for="(item, i) in $t('projectdci.menulists')"
                :key="i"
              >
                • {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 客户案例 -->
    <div
      class="case"
      id="cases"
    >
      <h1>{{$t('projectdci.case')}}</h1>
        <div class="botcolor">Customer case</div>
      <div class="services">
        <div class="servicetext">
          <ul>
            <div class="textfonts curbot fontw">{{$t('projectdci.demand')}}</div>
            <li
              v-for="(item, index) in $t('projectdci.serviceList')"
              :key="index"
              class="textfonts"
              :title="item.name"
            >
              • {{ item.name | caseellipsisd }}
            </li>
          </ul>
          <ul>
            <div class="textfonts curtop fontw">{{$t('projectdci.solution')}}</div>
            <li
              v-for="(item, index) in $t('projectdci.serviceLists')"
              :key="index"
              class="textfonts"
              :title="item.name"
            >
              • {{ item.name |caseellipsisd}}
            </li>
          </ul>
        </div>
        <div class="imgs">
          <img
            src="../../assets/img/product/DCIcase.png"
            alt=""
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      textlist: [
        {
          name: "高速互通",
          img: require("../../assets/img/product/spes.png")
        },
        {
          name: "稳定可靠",
          img: require("../../assets/img/product/stab.png")
        },
        {
          name: "安全",
          img: require("../../assets/img/product/save.png")
        },
        {
          name: "按需购买",
          img: require("../../assets/img/product/buy.png")
        }
      ],
      spelist: [
        {
          name: "单点接入，全网贯通",
          img: require("../../assets/img/product/04.png"),
          title:
            "连接天弛的任一节点即可获得与多个网络提供应用商的连接条件。企业通过扩容带宽即可满足业务增量需求，避免建议多条链路"
        },
        {
          name: "多地域接入",
          img: require("../../assets/img/product/05.png"),
          title:
            "天弛提供覆盖华北、华东、华南、港澳台及海外的100多个POP节点，企业可根据自身业务需求选择就近节点接入"
        },
        {
          name: "可视化管理",
          img: require("../../assets/img/product/06.png"),
          title: "在线自助开通，业务可视化管理"
        },
        {
          name: "快速开通",
          img: require("../../assets/img/product/01.png"),
          title: "最快3天建立DC节点直连"
        },
        {
          name: "按需配置",
          img: require("../../assets/img/product/02.png"),
          title: "1MBPS-10Gbps同带宽可调支持弹性增长"
        },
        {
          name: "实时监测",
          img: require("../../assets/img/product/03.png"),
          title: "实时网络监控及监测提供流量报告"
        }
      ],
      serviceList: [
        {
          name: "客户北京和上海分别有数据中心，需要实时数据备份"
        }
      ],
      serviceLists: [
        {
          name: "客户两地数据中心均在天弛SDN高可用网络的POP节点上"
        },
        {
          name: "通过两地数据中心机房内跳线，客户设备接入天弛SDN高可用网络上"
        },
        {
          name:
            "客户可以实现数据实时备份，可快速恢复，避免发生自然灾害等意外时导致数据丢失"
        }
      ],
      selected: 0,
      activeIndex: "1",
      title: "DCI简介",
      matter:
        "DCI业务是天弛网络提供的高速、安全、稳定的专线连接服务，基于天弛网络SDN网络满足网内不同地域DC-DC的互联需求。帮助企业快速构建高质量私有网络，实现DCI等多种场景的网络融合。",
      about:this.$t('projectdci.about'),
      menuimg: require("../../assets/img/product/cloud.png"),
      menustitle: "两地三中心容灾",
      text2: [
        {
          title:
            "通过天弛DCI产品，在同城数据中心节点上建立备份，可以实现服务和数据快速恢复；在异地数据中心节点上建立备份，避免发生自然灾害等意外时导致数据丢失"
        }
      ],
      menustitles: "解决的问题",
      list: "",
      menulists: [
        {
          title:
            "全程采用天弛SDN高可用网络，实现两地三中心互联，保证数据实时同步"
        },
        {
          title: "全面保障服务和数据安全，提升服务可用率"
        }
      ],
      selecteds: ""
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.query.type) {
        document.getElementById("cases").scrollIntoView();
      }
    });
  },
  methods: {
    mouseOvers(it) {
      switch (it) {
        case 0:
          this.selecteds = it;
          break;
        case 1:
          this.selecteds = it;
          break;
        case 2:
          this.selecteds = it;
          break;
        default:
          this.selecteds = it;
          break;
      }
    },
    mouseOver(it) {
      switch (it) {
        case 0:
          this.selected = it;
          this.about =this.$t('projectdci.about');
          break;
        case 1:
          this.selected = it;
          this.about =this.$t('projectdci.about2');
          break;
        case 2:
          this.selected = it;
          this.about =this.$t('projectdci.about3');
          break;
        case 3:
          this.selected = it;
          this.about =this.$t('projectdci.about4');
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.projectsContainer {
  width: 100%;
  height: auto;
  // 顶部标题
  .backimg {
    position: relative;
    overflow: hidden;
    .contents {
      width: 100%;
      height: 200px;
      position: absolute;
      bottom: 0;
      opacity: 0.9;
      background-color: rgb(41, 55, 43);
      .navs {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .list {
          width: 300px;
          height: 200px;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
        }
        .listback {
          background: url("../../assets/img/product/backcover.png") no-repeat
            center center;
          background-size: 100% 100%;
        }
        .jiesh {
          width: 100%;
          img {
            // width: 96px;
            // height: 100px;
            // vertical-align: middle;
            object-fit: contain;
          }
          .tixt {
            margin-top: 10px;
          }
          .green {
            color: #248f47;
          }
        }
      }
    }
    .betweencenter {
      width: 1200px;
      margin: 0 auto;
      .real {
        position: absolute;
        top: 150px;
        z-index: 1000;
        text-align: left;
        .tis {
          width: 420px;
          letter-spacing: 0px;
          line-height: 16px;
          font-size: 48px;
        }
        .tixt {
          width: 520px;
          margin-top: 36px;
          line-height: 21px;
          letter-spacing: 1px;
        }
      }
    }
  }
  .heif {
    height: 80px;
    line-height: 80px;
    background-color: #255033;
    margin-top: -1px;
  }
  .projectContent {
    width: 1200px;
    margin: 0 auto;
    // 标题
    .headers {
      text-align: left;
      margin-top: 30px;
      margin-bottom: 80px;
      img {
        vertical-align: middle;
        // width: 45px;
        // height: 43px;
      }
      span {
        margin-left: 16px;
        vertical-align: middle;
      }
      .matter {
        text-align: left;
        line-height: 1.5;
        margin-top: 50px;
      }
    }
  }
  // 产品特色
  .specil {
    width: 100%;
    height: 1085px;
    background-color: #f4f4f4;
    padding-top: 60px;
    box-sizing: border-box;
    .navs {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      width: 1200px;
      margin: 0 auto;
      margin-top: 60px;
      .list {
        width: 480px;
        height: 394px;
        background-color: #ffffff;
        display: flex;
        justify-content: space-around;
        align-content: center;
        flex-wrap: wrap;
        margin-bottom: 20px;
      }
      .list:hover {
        background: url("../../assets/img/product/cover.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
      .jiesh {
        box-sizing: border-box;
        margin-top: 53px;
        padding: 0 20px;
        img {
          object-fit: contain;
        }
        .tixt {
          font-size: 18px;
          color: #333;
          margin-top: 30px;
          margin-bottom: 40px;
        }
        .green {
          color: #248f47;
        }
      }
    }
  }
  // 应用场景
  .scene {
    .menus {
      width: 1161px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      margin-top: 60px;
      margin-bottom: 68px;
      .classl {
        width: 523px;
        height: 521px;
        display: flex;
        align-items: center;
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
      .classr {
        width: 443px;
        box-sizing: border-box;
        text-align: left;
        .classt {
          margin-bottom: 60px;
        }
        .font {
          margin-bottom: 50px;
        }
      }
    }
  }
  // 客户案例
  .case {
    width: 100%;
    background-color: #f4f4f4;
    padding: 60px 0 82px 0;
    box-sizing: border-box;
    .services {
      width: 1200px;
      height: 550px;
      margin: 0 auto;
      display: flex;
      justify-content: left;
      margin-top: 60px;
      background: url("../../assets/img/product/casebacks.png") no-repeat center
        center;
      background-size: 100% 100%;
      padding: 50px;
      box-sizing: border-box;
      position: relative;
      .service {
        width: 340px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .servicetext {
        text-align: left;
        margin-left: 50px;
        line-height: 27px;
        width: 540px;
        margin-top: -30px;
        .curbot {
          margin-bottom: 26px;
        }
        .curtop {
          margin: 26px 0;
        }
      }
      .imgs {
        width: 500px;
        height: 375px;
        position: absolute;
        bottom: 5px;
        right: 40px;
        img {
          // width: 100%;
          // height: 100%;
          // vertical-align: middle;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
